export default {
  state: {
    gqlErrors: {
      User_email_key: "Email used before",
      email: "Email must be a valid email"
    }
  },
  actions: {},
  mutations: {
    translateGraphqlErrors: (state, message) => {
      // const key = message.match(/"([^"]*)"/)[1];
      // alert(state.gqlErrors[key]);
      alert(message);
    }
  },
  getters: {},
  namespaced: true
};
